module.exports = __webpack_public_path__ + "img/ico-work.3448870d.svg";